import React from 'react';
import styles from "./DesktopPane.module.scss";
import { Typography } from 'seagull';
import { Stepper } from "../Stepper";
import { relationshipModel } from "../../../../models";
import { useCobConfig } from "../../../clientOb/CobConfigContext";
export const DesktopPane = _ref => {
  let {
    stepperSteps,
    activeStepIndex,
    onStepClick,
    completedSteps,
    activeSteps,
    'data-testid': testid
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  const vendorLogoUrl = relationshipModel.vendorLogoUrl({
    vendor: relationship.vendor
  });
  return /*#__PURE__*/React.createElement("aside", {
    className: styles.root,
    "data-testid": testid
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stepper
  }, vendorLogoUrl ? /*#__PURE__*/React.createElement("div", {
    "data-testid": testid && "".concat(testid, "-logo"),
    className: styles.logoImg,
    style: {
      backgroundImage: "url(".concat(vendorLogoUrl, ")")
    }
  }) : /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: styles.logoTxt
  }, relationship.vendor.name), /*#__PURE__*/React.createElement(Stepper, {
    steps: stepperSteps,
    completedSteps: completedSteps || [],
    activeStepIndex: activeStepIndex,
    onStepClick: onStepClick,
    "data-testid": testid && testid + '-stepper',
    activeSteps: activeSteps || []
  })));
};